export interface JsonModelConverterConfig {
  nullValue?: boolean;
  hasMany?: boolean;
}
